import ganttStore from './ganttStore';

export function drawTargetEndLayer(ganttId) {
  const gantt = ganttId ? ganttStore.getGantt(ganttId) : this;
  // gantt.attachEvent('onTaskLoading', function (task) {
  //   task.scheduled_end_date = task.scheduled_end_date
  //     ? task.scheduled_end_date instanceof Date
  //       ? task.scheduled_end_date
  //       : gantt.date.parseDate(task.scheduled_end_date, '%Y-%m-%d')
  //     : undefined;
  //   return true;
  // });

  // gantt.attachEvent('onBeforeTaskChanged', (id, mode, oldTask) => {
  //   if (oldTask.status !== 'active') {
  //     let task = gantt.getTask(id);
  //     if (mode === gantt.config.drag_mode.resize) {
  //       task.scheduled_end_date = task.end_date;
  //     } else if (mode === gantt.config.drag_mode.move) {
  //       task.scheduled_end_date = task.end_date;
  //     }
  //   }
  //   return true;
  // });

  gantt.addTaskLayer({
    renderer: {
      render: (task) => {
        if (task.forecasted_end_date && task.end_date) {
          let sizes = {};
          const el = document.createElement('div');
          el.setAttribute('data-id', task.id);
          if (task.forecasted_end_date > task.end_date && task.end_date > task.start_date) {
            sizes = gantt.getTaskPosition(task, task.end_date, task.forecasted_end_date);
            el.className = 'targetEndDate orange';
            el.style.left = sizes.left + -3 + 'px';
            el.style.borderRadius = '0px 2px 2px 0px';
            el.style.width = sizes.width - 3 + 'px';
          } else if (task.forecasted_end_date < task.end_date) {
            sizes = gantt.getTaskPosition(task, task.forecasted_end_date, task.end_date);
            el.className = 'targetEndDate green';
            el.style.left = sizes.left - 3 + 'px';
            el.style.borderRadius = '0 2px 2px 0';
            el.style.width = sizes.width + 'px';
          } else if (task.forecasted_end_date > task.end_date && task.end_date < task.start_date) {
            sizes = gantt.getTaskPosition(task, task.end_date, task.forecasted_end_date);
            el.className = 'targetEndDate orange';
            el.style.left = sizes.left + 'px';
            el.style.borderRadius = '2px 0px 0px 2px';
            el.style.width = sizes.width + 3 + 'px';
          } else {
            return false;
          }
          if (gantt.config.highlight_critical_path && gantt.isCriticalTask(task)) {
            el.className += ' critical';
          }
          el.style.height = sizes.height + 'px';
          el.style.top = sizes.top + 9 + 'px';
          return el;
        }
        return false;
      },
      getRectangle: function (task, view) {
        if (task.forecasted_end_date > task.end_date) {
          return gantt.getTaskPosition(task, task.end_date, task.forecasted_end_date);
        } else if (task.forecasted_end_date < task.end_date) {
          return gantt.getTaskPosition(task, task.forecasted_end_date, task.end_date);
        } else {
          return false;
        }
      },
    },
  });
}

export function drawForecastedStart(ganttId) {
  const gantt = ganttId ? ganttStore.getGantt(ganttId) : this;

  gantt.addTaskLayer({
    renderer: {
      render: (task) => {
        if (task.forecasted_start_date && task.start_date > task.forecasted_start_date) {
          let sizes = {};
          const el = document.createElement('div');
          el.setAttribute('data-id', task.id);

          sizes = gantt.getTaskPosition(task, task.forecasted_start_date, task.start_date);
          el.className = 'targetEndDate grey';

          el.style.left = sizes.left + 6 + 'px';
          el.style.borderRadius = '0px 2px 2px 0px';
          el.style.width = sizes.width - 3 + 'px';
          el.style.height = sizes.height + 'px';
          el.style.top = sizes.top + 9 + 'px';
          return el;
        }
        return false;
      },
      getRectangle: function (task, view) {
        if (task.forecasted_start_date && task.start_date > task.forecasted_start_date) {
          return gantt.getTaskPosition(task, task.forecasted_start_date, task.start_date);
        } else {
          return false;
        }
      },
    },
  });
}
